import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { onMounted, onBeforeMount, watch, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
// import { useUserStore } from "@/stores/userStore";

export default {
  __name: 'App',
  setup: function setup(__props) {
    var queryParams = new URLSearchParams(window.location.search);
    var channel = queryParams.get("channel") || "";
    var route = useRoute();
    var ip_name = ref(route.params.id);
    (function () {
      var device = navigator.userAgent.toLowerCase();
      var current_device = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(device) ? "mobile" : "pc";
      window.current_device = current_device;
    })();

    // 此段代码的作用是将SDK主文件未加载完成时，业务代码中调用的API依次进行放到数组q中缓存，等待SDK主文件加载完成后，再取出，并执行。
    (function (win, export_obj) {
      win["LogAnalyticsObject"] = export_obj;
      if (!win[export_obj]) {
        var _collect = function _collect() {
          _collect.q.push(arguments);
        };
        _collect.q = _collect.q || [];
        win[export_obj] = _collect;
      }
      win[export_obj].l = +new Date();
    })(window, "collectEvent");
    window.collectEvent("init", {
      app_id: 20001596,
      // 参考2.1节获取，注意类型是number而非字符串
      channel_domain: "https://gator.volces.com",
      // 设置数据上送地址
      log: true,
      // true:开启日志，false:关闭日志
      autotrack: false,
      // 全埋点开关，true开启，false关闭
      enable_debug: true,
      // 调试
      // disable_auto_pv: true // 开启禁用PV上报的开关
      enable_native: true,
      // 5.1.3以下版本参数为Native，
      // 5.1.3以上版本修改为enable_native，但仍然兼容了Native的设置
      enable_stay_duration: true //开启停留时长。
    });
    // 此处可添加设置uuid、设置公共属性等代码
    window.collectEvent("start"); // 通知SDK设置完毕，可以真正开始发送事件了

    onBeforeMount(function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.6.feature.js";
      document.body.appendChild(script);
      var bili = document.createElement("script");
      bili.type = "text/javascript";
      bili.src = "https://s1.hdslb.com/bfs/cm/cm-sdk/static/js/track-collect.js";
      document.body.appendChild(bili);
    });
    onMounted(function () {
      window.collectEvent("config", {
        public_dev_env: process.env.VUE_APP_MODE,
        "public_data-appid": 401,
        app_region: "cn",
        app_platform: "web"
      });
      console.log(route.params.id);
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(function (_ref) {
          var Component = _ref.Component;
          return [(_openBlock(), _createBlock(_KeepAlive, null, [_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _ctx.$route.name
          })) : _createCommentVNode("", true)], 1024)), !_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _ctx.$route.name
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      });
    };
  }
};